import * as React from 'react';
import { HiddenA11yText, StyledExternalLink, ExternalText, StyledExternalIcon } from './Link.styles';

const ExternalIcon = ({ children }) => {
    return (
        <>
            <StyledExternalIcon aria-hidden="true" />
            {children}
            <HiddenA11yText>, öppnar annan webbplats</HiddenA11yText>
        </>
    );
};

type Props = {
    href: string;
    children: React.ReactNode;
    className?: string;
};

const ExternalLink = ({ children, href, className }: Props) => {
    return (
        <StyledExternalLink href={href} className={className}>
            <ExternalIcon>
                <ExternalText>{children}</ExternalText>
            </ExternalIcon>
        </StyledExternalLink>
    );
};

export default ExternalLink;
